module.exports = __webpack_public_path__ + "img/education.5e53709c.png";